import { RegisteredComponent } from "@builder.io/sdk-react";

export const hiddenInputBlock: Omit<RegisteredComponent, "component"> = {
  name: "Hidden input",
  canHaveChildren: false,
  noWrap: true,
  inputs: [
    {
      name: "name",
      type: "string",
      required: true,
      localized: false,
    },
    {
      name: "value",
      type: "string",
      required: true,
      localized: false,
    },
  ],
};
